var _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBigGrid = function SvgBigGrid(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.446)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.446)",
    fill: "none",
    stroke: "#5a6798",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.446 12)",
    fill: "none",
    stroke: "#5a6798",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.554)",
    fill: "none",
    stroke: "#5a6798",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.554 12)",
    fill: "none",
    stroke: "#5a6798",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "none"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBigGrid, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjQ0NikiPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuNDQ2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNWE2Nzk4IiBzdHJva2Utd2lkdGg9IjEiPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgcng9IjEuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuNDQ2IDEyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNWE2Nzk4IiBzdHJva2Utd2lkdGg9IjEiPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgcng9IjEuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuNTU0KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNWE2Nzk4IiBzdHJva2Utd2lkdGg9IjEiPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgcng9IjEuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuNTU0IDEyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNWE2Nzk4IiBzdHJva2Utd2lkdGg9IjEiPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgcng9IjEuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };